import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
export function FrequentlyBoughtTogether() {
  const [selectedProducts, setSelectedProducts] = useState([0, 1, 2]);
  const products = [{
    id: 1,
    name: 'Gold Standard Whey Protein',
    brand: 'Optimum Nutrition',
    price: 189.99,
    originalPrice: 249.99,
    image: PRODUCT_IMAGES[0]
  }, {
    id: 2,
    name: 'Creatine Monohydrate',
    brand: 'MuscleTech',
    price: 79.99,
    originalPrice: 99.99,
    image: PRODUCT_IMAGES[1]
  }, {
    id: 3,
    name: 'Pre-Workout Energy',
    brand: 'C4',
    price: 129.99,
    originalPrice: 159.99,
    image: PRODUCT_IMAGES[2]
  }];
  const toggleProduct = (index: number) => {
    if (selectedProducts.includes(index)) {
      setSelectedProducts(selectedProducts.filter(i => i !== index));
    } else {
      setSelectedProducts([...selectedProducts, index]);
    }
  };
  const totalPrice = selectedProducts.reduce((sum, index) => sum + products[index].price, 0);
  const totalOriginalPrice = selectedProducts.reduce((sum, index) => sum + products[index].originalPrice, 0);
  return <div className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden shadow-sm" data-id="element-5002" data-mp="1zudf3oh2rm8w">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#1E2B55] to-[#2a3a6f] p-4" data-id="element-5003" data-mp="24tgo1k06ecm5">
        <h3 className="text-lg font-bold text-white" data-id="element-5004" data-mp="2shq3m46sq44u">
          Frequently Bought Together
        </h3>
        <p className="text-sm text-blue-100 mt-1" data-id="element-5005" data-mp="2xfhviy7fxq91">
          Save more when you buy these products together
        </p>
      </div>
      {/* Products */}
      <div className="p-4" data-id="element-5006" data-mp="2npy95ikire9f">
        <div className="space-y-3" data-id="element-5007" data-mp="2np6ov3wdh2yg">
          {products.map((product, index) => <div key={product.id} className={`relative border-2 rounded-xl p-3 transition-all cursor-pointer ${selectedProducts.includes(index) ? 'border-[#1E2B55] bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`} onClick={() => toggleProduct(index)} data-id="element-5008" data-mp="3bf123mklstj8" data-mpi={index}>
              {/* Checkbox */}
              <button className={`absolute top-3 left-3 w-5 h-5 rounded border-2 flex items-center justify-center transition-all ${selectedProducts.includes(index) ? 'bg-[#1E2B55] border-[#1E2B55]' : 'bg-white border-gray-300'}`} data-id="element-5009" data-mp="3l1llhzhv0dzx">
                {selectedProducts.includes(index) && <CheckIcon className="w-3 h-3 text-white" data-id="element-5010" data-mp="32dgjoxkrj33r" />}
              </button>
              {/* Product Content */}
              <div className="flex items-center gap-3 pl-8" data-id="element-5011" data-mp="2xeviautryddq">
                {/* Product Image */}
                <div className="flex-shrink-0 w-16 h-16 bg-gray-50 rounded-lg overflow-hidden" data-id="element-5012" data-mp="2sgbueovmeriq">
                  <img src={product.image} alt={product.name} className="w-full h-full object-contain p-1" data-id="element-5013" data-mp="2ocdxmktrpssu" />
                </div>
                {/* Product Info */}
                <div className="flex-1 min-w-0" data-id="element-5014" data-mp="yyml5xxvesx2">
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-5015" data-mp="13ubsing4te3x">
                    {product.brand}
                  </p>
                  <h4 className="text-sm font-medium text-gray-900 mb-1 line-clamp-1" data-id="element-5016" data-mp="17v5e3a63qgtn">
                    {product.name}
                  </h4>
                  <div className="flex items-center gap-2" data-id="element-5017" data-mp="g6liekhz6iid">
                    <span className="text-base font-bold text-[#1E2B55]" data-id="element-5018" data-mp="g3zcepaqgb29">
                      SAR {product.price.toFixed(2)}
                    </span>
                    <span className="text-xs text-gray-400 line-through" data-id="element-5019" data-mp="p5p0bl5eorva">
                      SAR {product.originalPrice.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        {/* Total and Add to Cart */}
        <div className="mt-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border-2 border-blue-100" data-id="element-5020" data-mp="1fl6g5i0s6hh">
          <div className="flex items-center justify-between mb-3" data-id="element-5021" data-mp="243t7za5wg6r7">
            <div data-id="element-5022" data-mp="1z5jbmw8fv040">
              <p className="text-xs text-gray-600 mb-1" data-id="element-5023" data-mp="1z61jyr8dl4sa">Total Price</p>
              <div className="flex items-center gap-2" data-id="element-5024" data-mp="2cw4w2pdjji40">
                <span className="text-2xl font-bold text-[#1E2B55]" data-id="element-5025" data-mp="2cxpuwr6w1n7o">
                  SAR {totalPrice.toFixed(2)}
                </span>
                <span className="text-sm text-gray-400 line-through" data-id="element-5026" data-mp="2mt9oh6xzc9t9">
                  SAR {totalOriginalPrice.toFixed(2)}
                </span>
              </div>
              <p className="text-xs text-green-600 font-medium mt-1" data-id="element-5027" data-mp="2vur0ad4ctpc5">
                Save SAR {(totalOriginalPrice - totalPrice).toFixed(2)} (
                {Math.round((totalOriginalPrice - totalPrice) / totalOriginalPrice * 100)}
                % off)
              </p>
            </div>
          </div>
          <button className="w-full bg-gradient-to-r from-[#1E2B55] to-[#2a3a6f] hover:from-[#162041] hover:to-[#1E2B55] text-white font-bold py-3 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-[1.02]" data-id="element-5028" data-mp="xgpfznnafqvi">
            Add All to Cart
          </button>
        </div>
      </div>
    </div>;
}